<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        rounded
        color="primary"
        class="font-weight-normal"
        id="btn-download"
        v-on="on"
      >
        Download
        <v-icon
          class="ml-2"
          x-small
        >
          fas fa-caret-down
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="download('html')">
        <v-list-item-title>HTML</v-list-item-title>
      </v-list-item>
      <v-list-item @click="download('pdf')">
        <v-list-item-title>PDF</v-list-item-title>
      </v-list-item>
      <v-list-item
        class="hover-planilha"
        v-if="report && csvData"
      >
        <v-list-item-title>
          <export-excel
            :data="csvData"
            :name="name"
            :labels="labels"
            :fields="labels"
            type="xls"
          >
            Planilha
          </export-excel>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  props: {
    download: {
      type: Function,
      default: () => '',
    },
    csvData: {
      type: Array,
      default: () => [],
    },
    report: {
      type: String,
      default: 'RelatorioCMWS',
      required: true,
    },
  },
  data() {
    return {
      label: {
        horario: 'HORÁRIO',
        registro: 'REGISTRO',
        titulo: 'TÍTULO',
        localizacao: 'LOCALIZAÇÃO',
      },
      field: ['horario', 'registro', 'titulo', 'localizacao'],
    };
  },
  computed: {
    name() {
      return `${this.report}.xls`;
    },
    labels() {
      if (this.csvData && this.csvData[0]) {
        const labels = Object.keys(this.csvData[0]);
        const obj = labels.reduce((acc, cur) => {
          acc[cur] = cur;
          return acc;
        }, {});
        return obj;
      }
      return this.label;
    },
  },
};
</script>
<style scoped>
.hover-planilha:hover {
  background-color: #f6f6f6;
  cursor: pointer;
}
</style>
